export const TEST_ID = 'chemicalDetailWeather';
